module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-sys-7d0a137861e03a1f616ea81789fa6194.png";